import { isRuntimeSite } from '../helpers';
import { RequestMethod, request } from '../http';
function throttle(fn, delay, _temp) {
  let {
    leading
  } = _temp === void 0 ? {
    leading: false
  } : _temp;
  let timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer) {
      clearTimeout(timer);
    }
    if (leading) {
      fn(...args);
    }
    timer = setTimeout(() => {
      fn(...args);
      timer = null;
    }, delay);
  };
}
if (!globalThis?.notifyServerThrottled) {
  globalThis.notifyServerThrottled = throttle(notifyServer, 30000, {
    leading: false
  });
}
if (!globalThis?.evaluatedFlags) {
  globalThis.evaluatedFlags = new Set();
}
export function getInt(key, defaultVal) {
  return parseInt(String(get(key, defaultVal)), 10);
}
export function get(prop, defaultVal) {
  return getProp(prop, defaultVal, globalThis.commonProps);
}
export function getFlag(flag, defaultVal) {
  if (defaultVal === void 0) {
    defaultVal = false;
  }
  if (!get('featureFlag.fromCommonProps.enabled', false)) {
    globalThis.evaluatedFlags.add(flag);
    globalThis.notifyServerThrottled();
  }
  return getProp(flag, defaultVal, getFlagsContainer());
}
function getProp(prop, defaultVal, fromContainer) {
  if (fromContainer === void 0) {
    fromContainer = globalThis.commonProps;
  }
  const container = fromContainer || globalThis.commonProps || globalThis.rtCommonProps || {};
  return container[prop] === undefined ? defaultVal : container[prop];
}
function getFlagsContainer() {
  let container;
  if (window._flags) {
    container = window._flags;
  } else {
    try {
      container = window.parent._flags;
    } catch (e) {
      container = {};
    }
  }
  return container;
}
async function notifyServer() {
  // If we're on runtime site we do not wish to notify the server
  if (isRuntimeSite()) return;
  const flagsArray = Array.from(globalThis.evaluatedFlags);
  globalThis.evaluatedFlags.clear();
  if (!flagsArray.length) {
    return;
  }
  try {
    await request({
      url: `/api/uis/flags/notify`,
      method: RequestMethod.POST,
      body: JSON.stringify(flagsArray),
      keepalive: true
    });
  } catch (err) {
    console.warn(`Couldn't send flags evaluation (flags: ${flagsArray}):`, err);
  }
}
//# sourceMappingURL=index.js.map